import * as _ from 'lodash';
import { DropdownButton, MenuItem, SelectCallback } from 'react-bootstrap';
import { Repository } from '../../../types';
import utils from '../../../utils';

type BranchDropdownProps = {
  repo?: Repository;
  onBranchChange: Function;
};

const BranchDropdown = (props: BranchDropdownProps) => {
  const changeBranch = (branch: string, event) => {
    event.stopPropagation();
    event.preventDefault();
    props.onBranchChange(props.repo, branch);
  };

  const menuItems = props.repo?.branches?.map((branch) => (
    <MenuItem className="branch-item" eventKey={branch} key={branch}>
      {branch}
    </MenuItem>
  ));
  return (
    <span className="branch-dropdown">
      <DropdownButton
        id="serviceImportDropdownButton"
        onSelect={changeBranch as SelectCallback}
        onClick={utils.containEvent(_.noop)}
        title={
          (
            <span>
              <b>{props.repo?.branch}</b>
            </span>
          )
        }
        pullRight>
        {menuItems}
      </DropdownButton>
    </span>
  );
};

export default BranchDropdown;
